import {
  DISCHARGED_AS_INPT,
  INPATIENT,
} from '../constants/PatientStatus.constants';
import {
  LENGTH_OF_STAY_TIME_IN_DAYS,
  LENGTH_OF_STAY_TIME_IN_HOURS,
  TWENTY_FOUR,
} from '../constants/TimeCalculation.constants';

export const TotalLOSRenderer = ({ value, row }) => {
  const { admission_status } = row._original;
  if (admission_status) {
    let retVal = value;
    let unit = LENGTH_OF_STAY_TIME_IN_HOURS;
    if (
      admission_status.toUpperCase() === INPATIENT.toUpperCase() ||
      admission_status.toUpperCase() === DISCHARGED_AS_INPT.toUpperCase()
    ) {
      retVal = Math.ceil(retVal / TWENTY_FOUR);
      unit = LENGTH_OF_STAY_TIME_IN_DAYS;
    }

    return `${retVal} ${unit}`;
  }

  return '';
};
